import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import TextBox from '@components/TextBox/TextBox';
import HorizontalSlider from '@components/HorizontalSlider/HorizontalSlider';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const planeInfo = props => {
  let stylesContainer = {};
  if (window.innerWidth < 992) {
    stylesContainer.minHeight = props.screenHeight + 'px';
  } else {
    stylesContainer.height = props.screenHeight + 'px';
  }

  let styles = {};
  let classNames = '';
  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.backgroundImage = `url(${Clouds})`;
    styles.backgroundSize = '100% 100%';
    styles.backgroundPosition = 'center center';
    classNames = 'pt-6 pb-4';
  } else {
    styles.height = props.screenHeight + 'px';
    classNames =
      'abs-container d-flex align-items-center justify-content-center';
  }

  return (
    <div
      id={props.id}
      className={'panel d-flex align-items-center'}
      style={styles}
    >
      <img
        src={Clouds}
        alt={'Slider1'}
        className={'img-fluid d-none d-lg-block'}
      />
      <Container fluid={true} className={classNames} style={stylesContainer}>
        <Row>
          <Col md={{ offset: 1, size: 5 }}>
            <HorizontalSlider {...props} />
          </Col>
          <Col
            md={{ size: 4, offset: 1 }}
            className={'d-flex flex-column justify-content-center'}
          >
            <TextBox {...props} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default planeInfo;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/PlaneInfo/PlaneInfo.js